import React from 'react';
import { Link } from 'react-router-dom';
import { tools } from '../toolData';

export default function Navbar() {
  // Create a unique list of categories from tools
  const categories = [...new Set(tools.map(tool => tool.category))];

  return (
    <nav className="bg-gray-800 text-white py-4">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center space-y-2 md:space-y-0 md:flex-row md:justify-center">
        <Link to="/" className="text-xl font-bold text-blue-300 hover:text-blue-400 mr-6">All EE Tools</Link>
        <div className="flex flex-wrap justify-center gap-4 mt-2 md:mt-0">
          {categories.map((category) => (
            <Link
              key={category}
              to={`/category/${category}`}
              className="text-sm md:text-base text-blue-200 hover:text-blue-400 transition"
            >
              {category}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
